export default {"src":"/_next/static/media/trustpilotRating.5c53f12d.svg","height":20,"width":108,"blurWidth":0,"blurHeight":0};